export default __webpack_public_path__ + "static/media/Armstraps of Lunacy.a255f175.jpg";